import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASEURL;

/**
 * @function getIndividualData
 * @param (slug)
 * @description api to get individual list
 */
export const getIndividualData = async (slug) => {
    try {
        const result = await axios.get(`${baseUrl}/directory/v1/sports_complex/${slug}`);
        return result;
    } catch (err) {
        return err;
    }
};

/**
 * @function getNearbyVenues
 * @param (id)
 * @description api to get nearby venues list.
 */
export const getNearbyVenues = async (id) => {
    try {
        const result = await axios.get(`${baseUrl}/directory/v1/sports_complex/near-by/${id}`);
        return result;
    } catch (err) {
        return err;
    }
};
